import React from 'react';
import styled from "styled-components";

const SGrammarAdverbios = styled.div`
  flex: 1;
  padding: 5px 20px;
`;

const GrammarAdverbios = () => {
  return (
    <SGrammarAdverbios>
<h5>Adverbios - Przysłówki</h5>

<h6>Przysłówki sposobu</h6>
Tworzy się je od przymiotników w rodzaju żeńskim dodając końcówkę <i>-mente</i> (<b>seguramente</b> - pewnie, <b>alegremente</b> - wesoło). Przymiotniki <b>bueno</b> (dobry) i <b>malo</b> (zły) mają nieregularne formy przysłówków <b>bien</b> (dobrze) i <b>mal</b> (źle). Istnieje wiele przysłówków i wyrażeń przysłówkowych nie mieszczących się w powyższej regule, np. <b>despacio</b> (powoli), <b>apenas</b> (zaledwie), <b>con gusto</b> (z przyjemnością), <b>de antemano</b> (z góry), <b>de otra manera</b> (inaczej).

<h6>Przysłówki miejsca</h6>
<b>aquí</b> (tutaj), <b>ahí</b> (tam, miejsce odległe od mówiącego), <b>allí</b> (tam, miejsce odległe od mówiącego i słuchającego). Inne najczęstsze przysłówki miejsca to: <b>abajo</b> (na dole), <b>arriba</b> (na górze), <b>cerca</b> (blisko), <b>enfrente</b> (naprzeciwko), <b>lejos</b> (daleko).

<h6>Przysłówki czasu</h6>
<b>ahora</b> (teraz), <b>manana</b> (jutro), <b>mientras</b> (podczas gdy), <b>antes</b> (dawniej), <b>ayer</b> (wczoraj), <b>cuando</b> (kiedy), <b>entonces</b> (wtedy), <b>luego</b> (potem), <b>nunca</b> (nigdy), <b>siempre</b> (zawsze), <b>tarde</b> (poźno), <b>temprano</b> (wcześnie). Częste zwroty przysłówkowe to: <b>a menudo</b> (często), <b>a veces</b> (czasami), <b>dentro de poco</b> (wkrótce), <b>de golpe</b> (nagle), <b>hace poco</b> (niedawno), <b>mucho tiempo</b> (długo), <b>para siempre</b> (na zawsze).

<h6>Przysłówki ilości</h6>
<b>bastante</b> (dosyć), <b>casi</b> (prawie), <b>cuanto</b> (ile), <b>demasiado</b> (za dużo), <b>medio</b> (pół), <b>mucho</b> (dużo, używa się przed rzeczownikami i przy określaniu czasownika), <b>muy</b> (bardzo, używa się przed przymiotnikami i przysłówkami), <b>nada</b> (nic), <b>poco</b> (mało). Wyrażenia przysłówkowe: <b>más o menos</b> (mniej więcej), <b>por lo menos</b> (przynajmniej).

<h6>Przysłówki pytajne</h6>
<b>cómo</b> (jak), <b>dónde</b> (gdzie), <b>a dónde</b> (dokąd), <b>de dónde</b> (skąd), <b>por dónde</b> (którędy), <b>cuándo</b> (kiedy), <b>hasta cuándo</b> (do kiedy), <b>desde cuándo</b> (od kiedy).

<h6>Stopniowanie przysłówków</h6>
Stopień wyższy przysłówka tworzy się poprzedzając go słowem <i>más</i>, a najwyższy - dodając do wyższego rodzajnik <i>lo</i>:<br/>
<b>temprano</b> - wcześnie<br/>
<b>más temprano</b> - wcześniej<br/>
<b>lo más temprano</b> - najwcześniej<br/>
<br/>
Przysłówki <b>bien</b>, <b>mal</b>, <b>mucho</b> i <b>poco</b> mają nieregularne stopniowanie:<br/>
<b>bien</b> - dobrze -  <b>mejor</b> - lepiej<br/>
<b>mal</b> - źle -  <b>peor</b> - gorzej<br/>
<b>mucho</b> - dużo -  <b>más</b> - więcej<br/>
<b>poco</b> - mało -  <b>menos</b> - mniej
    </SGrammarAdverbios>
  );
};

export default GrammarAdverbios;